import { render, staticRenderFns } from "./AddQualityGradeModal.vue?vue&type=template&id=085a97c6"
import script from "./AddQualityGradeModal.vue?vue&type=script&lang=js"
export * from "./AddQualityGradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports